import { ChangeEvent } from 'react'
import { useField } from 'formik'
import { MenuItem } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  InputContainer,
  Wrapper,
  TextField,
  Select,
  HelperText,
  InputLabel,
} from './AmountInput.style'
import { Option } from 'shared/types'

interface PhoneNumberInputProps {
  selectName: string
  inputName: string
  label?: string | JSX.Element | (string | JSX.Element)[]
  prefixOptions?: Option[]
  disabled?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  labelComponent?: typeof InputLabel
}

const AmountInput = ({
  selectName,
  inputName,
  label,
  prefixOptions,
  disabled,
  onChange,
  labelComponent,
  ...props
}: PhoneNumberInputProps) => {
  const [selectField, { touched, error }] = useField(selectName)
  const [inputField, { touched: inputTouched, error: inputError }] =
    useField(inputName)
  const isError =
    !disabled && !!((inputError || error) && (touched || inputTouched))
  const LabelComponent = labelComponent || InputLabel

  return (
    <Wrapper {...props}>
      <LabelComponent disabled={disabled} error={isError}>
        {label}
      </LabelComponent>
      <InputContainer>
        <TextField
          disabled={disabled}
          {...inputField}
          error={isError}
          name={inputName}
          onChange={async e => {
            await inputField.onChange(e)
            onChange && onChange(e)
          }}
        />
        <Select
          disabled={disabled}
          error={isError}
          MenuProps={{
            disablePortal: true,
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            transformOrigin: { vertical: 'top', horizontal: 'center' },
          }}
          variant="outlined"
          {...selectField}
          IconComponent={ExpandMoreIcon}
        >
          {prefixOptions?.map(({ title, value }) => (
            <MenuItem key={value} value={value}>
              {title}
            </MenuItem>
          ))}
        </Select>
      </InputContainer>
      <HelperText error={isError}>{isError && inputError}</HelperText>
    </Wrapper>
  )
}

export default AmountInput
